export default {
  namespaced: true,
  state: {
    response: {},
  },
  getters: {
    acsurl: (state) => {
      if ($cookies.get('acsurl')) {
        return $cookies.get('acsurl');
      }
    },
    // for 3Dsv1 - This field will only be returned in case of fallback (fallback from 3DSv2 to 3DSv1).
    md: (state) => {
      if ($cookies.get('md')) {
        return $cookies.get('md');
      }
    },
    // for 3Dsv1 - This field will only be returned in case of fallback (fallback from 3DSv2 to 3DSv1).
    paReq: (state) => {
      if ($cookies.get('paReq')) {
        return $cookies.get('paReq');
      }
    },
    // new for 3Dsv2 - Will be set if card holder enrolled in 3Dsv2 (replaces MD)
    VPSTxId: (state) => {
      if ($cookies.get('VPSTxId')) {
        return $cookies.get('VPSTxId');
      }
    },
    // new for 3Dsv2 - Will be set if card holder enrolled in 3Dsv2 (replaces paReq)
    CReq: (state) => {
      if ($cookies.get('CReq')) {
        return $cookies.get('CReq');
      }
    },
    ga_LocalTime: (state) => {
      if ($cookies.get('ga_LocalTime')) {
        return $cookies.get('ga_LocalTime');
      }
    },
    guestLoginId: (state) => {
      if ($cookies.get('guestloginid')) {
        return $cookies.get('guestloginid');
      }
    },
  },
  mutations: {
    setResponse(state, data) {
      if (data) {
        $cookies.set('termurl', data.termurl, '15s', null, null, false);
        $cookies.set('acsurl', data.acsurl, '15s', null, null, false);
        $cookies.set('md', data.md, '15s', null, null, false);
        $cookies.set('paReq', data.paReq, '15s', null, null, false);

        // 3Dsv2
        $cookies.set('VPSTxId', data.vpsTxId, '15s', null, null, false);
        $cookies.set('CReq', data.cReq, '15s', null, null, false);

        $cookies.set('ga_LocalTime', data.ga_LocalTime, '15s', null, null, false);
        if (data.coSignIn) $cookies.set('guestloginid', data.coSignIn.id, '15s', null, null, false);
        else $cookies.remove('guestloginid');
      }
      else {
        $cookies.remove('termurl');
        $cookies.remove('acsurl');
        $cookies.remove('md');
        $cookies.remove('paReq');
        $cookies.remove('ga_LocalTime');
        $cookies.remove('guestloginid');
        $cookies.remove('VPSTxId');
        $cookies.remove('CReq');
      }
    },
  },

  setResponseCheckout(state, data) {
    if (data) {
      $cookies.set('threeDSecureURL', data.threeDSecureURL, '15s', null, null, false);
    }
  },

};

// Payment response from SAGE example
// cardPaymentResponse:
// acsurl: "https://test.sagepay.com/mpitools/accesscontroler?action=pareq"
// md: "2015658846965831628"
// paReq: "eJxVUtluwyAQfO9XWP4AY/ARHG2I0qZHVKWymvQDEEY1ra/4qOO/Lzh20/DCzsAOu7PA+pxn1o+sG1UWKxs7rr1md3BMaym3Bym6WjLYy6bhn9JSycomLg7CgFI/jPTm4ZBQm0G8eZcnBpMO0zIOBjRDLVCLlBctAy5O97s35kckcl1AE4Rc1rstC3zPjRbuvABdaCh4LlmbquL7oITKBkAjA6LsirYeGCUhoBlAV2csbdtqiVDf986Y14x5jihzQOYc0LWkuDNRo/XOKmGKNK/8maLj04eXVemXzB9PKVcF6ekKkLkBCW8l0z5ELsWBhcNlQJdYVzDywHNTCCOBt8C+7vACoTKvbG7P/nOgra5lIQYWLajuZkYgz1VZSJMF6C+GRDaCHcxQYj5Y+3innzcUoGs7Dy/Gb9FqC7GxeoyMntI2EeL6o6ABgMxdNE0RTfPW0c0/+AUqJ7Wo"
// status: 3
// statusDetails: "2007 : Please redirect your customer to the ACSURL, passing the MD and PaReq."
// statusDetailsDBFriendly: "3DAUTH - CARD Holder must be forwarded to the bank 3D secure form: 2007 : Please redirect your customer to the ACSURL, passing the MD and PaReq."
// threedSecureStatus: "OK"
// vendorTXCode: "ea2746ef-ee7f-4dcd-9d80-dee10cfdecb8"
